<ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOpen]="trigger().open()"
    [cdkConnectedOverlayOrigin]="trigger().origin"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    (backdropClick)="trigger().close()"
    (detach)="trigger().close()"
    (attach)="onAttach()"
>
    <ul
        tabindex="-1"
        tranDropdownKeyboard
        (closeRequested)="trigger().close()"
        class="flex flex-col bg-[var(--element-base-1)] p-3 gap-3"
    >
        @for (value of values(); track value) {
            <li>
                <button
                    type="button"
                    class="w-full cursor-pointer p-3 text-left transition-colors hover:bg-[var(--element-base-1-hover)] hover:text-[var(--element-text-primary)]"
                    [class.bg-[var(--element-base-1-selected)]]="value === selectedValue()"
                    [attr.data-selected]="value === selectedValue()"
                    (click)="selectValue(value)"
                >
                    {{ getLabel(value) | translate }}
                </button>
            </li>
        }
    </ul>
</ng-template>
